// TODO: add task to add these fields
export const convertCrossSellDetailsData = (data) => ({
  ...data,
  prevReferenceTmpl: 'Предыдущий товар',
  nextReferenceTmpl: 'Следующий товар',
});
